import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ClickOutsideModule } from 'ng-click-outside';

import { LayoutComponent } from './layout.component';
import { FooterComponent } from './footer/footer.component';
import { HorizontalComponent } from './horizontal/horizontal.component';
import { HorizontaltopbarComponent } from './horizontaltopbar/horizontaltopbar.component';
import { NavSidebarComponent } from './nav-sidebar/nav-sidebar.component';
import { MenuSidebarComponent } from './nav-sidebar/components/menu-sidebar/menu-sidebar.component';
import { TopbarSidebarComponent } from './nav-sidebar/components/topbar-sidebar/topbar-sidebar.component';
import { FormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { LayoutUserComponent } from './layout-user.component';

@NgModule({
  declarations: [
    LayoutComponent,
    LayoutUserComponent,
    FooterComponent,
    HorizontalComponent,
    HorizontaltopbarComponent,
    NavSidebarComponent,
    MenuSidebarComponent,
    TopbarSidebarComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbDropdownModule,
    ClickOutsideModule,
    PerfectScrollbarModule,
    FormsModule,
    NgbTooltipModule,
    NgSelectModule,
  ],
  exports: []
})
export class LayoutsModule { }
